import { ca } from '@cian/analytics';
import { IReview } from '../../components/Reviews';

const baseEventParams = {
  category: 'house_projects_block',
  name: 'oldevent',
};

export const trackReviewsScroll = () => {
  ca('eventSite', {
    ...baseEventParams,
    action: 'show',
  });
};

export const trackReviewItemClick = (review: IReview) => {
  ca('eventSite', {
    ...baseEventParams,
    action: 'click',
    label: review.title,
  });
};

export const trackAllReviewsClick = () => {
  ca('eventSite', {
    ...baseEventParams,
    action: 'click',
    label: 'all_reviews',
  });
};
